import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StateManagementService } from '../services/state-management.service';

export const superAdminGuard: CanActivateFn = () => {
  const stateService = inject(StateManagementService);
  const router = inject(Router);

  if (stateService.isSuperAdmin()) {
    return true;
  }

  return router.createUrlTree(['/dashboard']);
};
